import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Alert } from 'rsuite';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../../data';
import { SetupFarmaFormValues, toUpdateConfigFarmaPayload } from '../schema';
import { getConfigFarma, updateConfigFarma } from '../service/IPAConfigFarma';

const SETUP_FARMA_QUERY_KEY = ['ipa.setup-farma'];

export const useFarma = () => {
  const queryClient = useQueryClient();

  const { data: configFarma } = useQuery({
    queryKey: SETUP_FARMA_QUERY_KEY,
    queryFn: getConfigFarma,
  });

  const mutation = useMutation({
    mutationFn: updateConfigFarma,
    onSuccess: () => {
      Alert.success('Configurações salvas com sucesso');
      queryClient.invalidateQueries(SETUP_FARMA_QUERY_KEY);
    },
    onError: () => {
      const { message } = new Exception('Erro ao salvar as configurações');
      AlertWithTimestamp({ message });
    },
  });

  const saveConfigFarma = (values: SetupFarmaFormValues) => mutation.mutate(toUpdateConfigFarmaPayload(values));

  return {
    configFarma,
    saveConfigFarma,
    isUpdating: mutation.isLoading,
  };
};
